import { memo as Memo } from 'react';

//* Components
import Video from '../Video';

//* Styles
import VideoContentStyle from './style';

const VideoContent = Memo(({ data }) => {
	return (
		<VideoContentStyle className={`videoCont ${data.position === 'full' ? 'full' : ''} ${data.position === 'right' ? 'right' : ''} ${data.position === 'left' ? 'left' : ''}`}>
			<Video data={data.content.fields.file.url} />
		</VideoContentStyle>
	);
});

export default VideoContent;
